enum UserChainRole {
	OWNER = 'owner',
	ADMIN = 'admin',
	EMPLOYEE = 'employee',
}

export default UserChainRole;
